/* Question14 in adobe */
import React, { useCallback, useContext, useEffect, useState, useRef } from "react";

import {
  Hero,
  ContactProfile,
  Back,
  LinearGradient,
} from "../../../../components";

import {
  Container,
  Section,
  Gap,
  NavigateButtons,
  CenterWrapper,
  LoadingSpinner,
} from "./styles";
import { Contact3 } from "../../../../assets/contact-profile";
import { NavigateButtonsContext, DataUserContext } from "../..";
import {
  getCities,
  getStates,
  getStores,
  getStoresByLink,
  getWhatsappLink,
  finishJourneyEspecificador,
} from "../../../../services/data-service/api";
import { ThemeContext, DefaultTheme } from "styled-components";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";
import useIsElementVisible from "../../../../components/Pagination/index";
import { useLocation } from "react-router-dom";
  
interface ICity {
  id: number;
  nome: string;
}

interface IStore {
  id: number;
  nome: string;
  cidade_id: number;
  empresa_id: number;
  telefone1: string;
  telefone2: string;
  endereco: string;
  cidade: string[];
  estado: string[];
  bairro: string;
  link: string;
  url: string;
}

interface States {
  uf: string;
  nome: string;
}

const Question23: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);

  const [cities, setCities] = useState<string[]>([]);
  const [state, setState] = useState<string>("");
  const [city, setCity] = useState<string>("");
  const [rawCities, setRawCities] = useState<ICity[]>([]);
  const [cityId, setCityId] = useState<number>();
  const [bairro, setBairro] = useState<string>("");
  const [bairros, setBairros] = useState<string[]>([]);
  const [stores, setStores] = useState<IStore[]>([]);
  const [showCity, setshowCity] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingPagination, setIsLoadingPagination] = useState<boolean>(false);
  const [reloadProp, setReload] = useState<boolean>(false);
  let [lojasWithWhatsappLink, setLojaWhats] = useState<IStore[]>([]);

  const [brazilianStates, setBrazilianStates] = useState<string[]>();

  const location = useLocation();
  
  const [pagination, setPagination] = useState({
    itens: [],
    page: 0,
    totalPages: 1,
  });
  const lastRef = useRef(null);
  const isLastVisible = useIsElementVisible(lastRef.current);

  useEffect(() => {
    async function fetchStates() {
      const { estados } = await getStates(token);

      const UFS = estados.map((estado: States) => estado.uf);

      setBrazilianStates(UFS);
    }

    fetchStates();
  }, []);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 15);
  }, []);

  async function handleSelectedState(e: React.ChangeEvent<HTMLSelectElement>) {
    const state = e.target.value;
    setState(state);

    const { cidades, rawData } = await fetchCities(state, token);
    setRawCities(rawData);
    setCities(cidades);
  }

  async function handleSelectedCity(e: React.ChangeEvent<HTMLSelectElement>) {
    // setIsLoading(true);
    const city = e.target.value;
    setCity(city);
    // setBairro('');

    setPagination({
      itens: [],
      page: 0,
      totalPages: 1
    })
    let citySelectId = rawCities.find(({ nome }: ICity) => nome === city)?.id;
    setCityId(citySelectId);

    const { bairros } = await fetchBairros(citySelectId, token);
    setBairros(bairros);
    setBairro('Selecione o bairro');
  }
  
  async function handleSelectedDistrict(e: React.ChangeEvent<HTMLSelectElement>) {
    setIsLoading(true);
    
    setReload(true);
    setPagination({
      itens: [],
      page: 0,
      totalPages: 1
    })

    const district = e.target.value;
    setBairro(district);

  }

  const [markerStore, setmarkerStore] = useState( [] );

  async function handleWhatsappClick(storeId: number) {
    await finishJourneyEspecificador(storeId, token);
  }

  async function fetchBairros(cityId: number, token: string) {
    const { cidades: lojas } = await getStores(cityId, token);

    setReload(true);
    setPagination({
      itens: [],
      page: 0,
      totalPages: 1
    })
    let sendBairrro = lojas.map(({bairro}) => ( bairro.toUpperCase() ))
    sendBairrro = sendBairrro.sort((a, b) => a.localeCompare(b));
    sendBairrro = [...new Set(sendBairrro)];

    return {
      bairros: sendBairrro,
    };
  }

  async function fetchCities(state: string, token: string) {
    const { cidades } = await getCities(state, token);

    setReload(true);
    setPagination({
      itens: [],
      page: 0,
      totalPages: 1
    })

    return {
      cidades: cidades.map(({ nome }: ICity) => nome),
      rawData: cidades,
    };
  }
  
  const fetchStores = useCallback(async (cityId: number, bairro: string, token: string, page: number) => {
    var preLojas;
    if( location.pathname === '/' ) {
        preLojas = await getStores(cityId, token);
    } else {
        preLojas = await getStoresByLink(location.pathname.substring(1), token);
        if( preLojas.cidades.length == 0){
          preLojas = await getStores(cityId, token);
          setshowCity(true);
        }
    }

    const initial = 6 * page - 6;
    const final = 6 * page;
    const { cidades: lojas } = preLojas;

    lojas.sort((a, b) => a.nome.localeCompare(b.nome));

    let lojasPagination = lojas;
    if( location.pathname === '/' || showCity ){
      lojasPagination = lojas.filter(function(item, index) {
        return !!!bairro || bairro == '' || bairro == 'Selecione o bairro' || item.bairro.toUpperCase() === bairro.toUpperCase()
      });
    }
    let total = lojasPagination.length / 6;

    let makeMarkerStore = [];
    for (const loja of lojasPagination) {
      makeMarkerStore.push({lat: loja.latitude, lng: loja.longitude});
    }
    setmarkerStore(makeMarkerStore);

    lojasPagination = lojasPagination.filter(function(item, index) {
      return (index >= initial && index < final);
    });

    for (const loja of lojasPagination) {
      lojasWithWhatsappLink.push(loja);
    }

    if(page == 1){
      lojasWithWhatsappLink = lojasPagination;
      setStores(lojasPagination);
    } else {
      setStores(lojasWithWhatsappLink);
    }
    setLojaWhats(lojasWithWhatsappLink);

    setPagination({
      itens: lojasPagination,
      page: page,
      totalPages: total,
    })
    setIsLoading(false);
    setIsLoadingPagination(false);

  }, []);

  async function fetchWhatsappLink(lojaId: number, token: string) {
    const { link } = await getWhatsappLink(lojaId, token);

    return link;
  }

  useEffect(() => {
    if (location.pathname !== '/'){
        fetchStores(null, '', token, pagination.page + 1);
    }
  }, [location.pathname, token, fetchStores]);
  
  // useEffect(() => {
  //   if (cityId && bairro == '') fetchStores(cityId, '', token, pagination.page + 1);
  // }, [cityId, token, fetchStores]);

  useEffect(() => {
    if (bairro && bairro != 'Selecione o bairro'){
      fetchStores(cityId, bairro, token, pagination.page + 1);
    }
  }, [bairro, token, fetchStores]);

  useEffect(() => {
    if (isLastVisible) {
      setIsLoadingPagination(true);
      setReload(false);
      if (cityId) fetchStores(cityId, '', token, pagination.page + 1);
    }
  }, [isLastVisible, token, fetchStores]);

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_final.propriedades.imagens.etapa_final_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_final.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_final.propriedades.conteudo.titulo"
              )}
              ​
            </p>

            {(location.pathname === '/' || showCity) && 
                <>
                    <select name="states" id="states" defaultValue="" onChange={handleSelectedState}>
                      <option value="" disabled>
                        Selecione o estado 
                      </option>
                      {brazilianStates &&
                        brazilianStates.map((state) => <option>{state}</option>)}
                    </select>

                    <select name="cities" id="cities" defaultValue="" onChange={handleSelectedCity}>
                      <option value="" disabled>
                        Selecione a cidade
                      </option>
                      {cities.map((city) => (
                        <option>{city}</option>
                      ))}
                    </select>

                    <select name="district" id="district" onChange={handleSelectedDistrict}>
                      <option value="">
                        Selecione o bairro
                      </option>
                      {bairros.map((district) => (
                        <option>{district}</option>
                      ))}
                    </select>
                </>
            }

            <Gap />

            {isLoading ? (
              <CenterWrapper>
                <LoadingSpinner />
              </CenterWrapper>
            ) : (
              stores.map(
                ({
                  id,
                  nome,
                  endereco,
                  cidade,
                  estado,
                  bairro,
                  telefone1,
                  telefone2,
                  link,
                  url
                }) => (
                  <ContactProfile
                  criare
                    photo={url || Contact3}
                    name={`Criare ${nome}`}
                    address={`${endereco}, ${bairro} - ${city.toUpperCase() || cidade['nome'].toUpperCase()} - ${state.toUpperCase() || estado['uf'].toUpperCase()}`}
                    phone={
                      telefone1 && telefone2
                        ? `${telefone1} | ${telefone2}`
                        : telefone1
                        ? `${telefone1}`
                        : ""
                    }
                    // if (telefone1 && telefone2) `${telefone1} | ${telefone2}`
                    // if (telefone1) `${telefone1}`
                    // ""
                    // (telefone1 && telefone2) ? `${telefone1} | ${telefone2}` : telefone1 ? `${telefone1}` : ""
                    link={link}
                    onClick={() => handleWhatsappClick(id)}
                  />
                )
              )
            )}

            <Gap />

            {isLoadingPagination ? (
              <CenterWrapper>
                <LoadingSpinner />
              </CenterWrapper>
            ) : ''}

            {!!pagination.itens.length && pagination.page < pagination.totalPages && (
              <div ref={lastRef} />
            )}

          </Section>

          <Gap />
          
          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
        
      )}
    </>
  );
};

export default Question23;
